import { Avatar, Button, Paragraph } from '@quickmd-llc/design-system';
import { tracking, Events } from '@lib/events';
import { Provider } from '@types';
import formatProviderName from '@utils/misc/formatProviderName';
import formatProviderNameWithTitle from '@utils/misc/formatProviderNameWithTitle';
import { useParseTimeBlockSearchParam } from '../context/utils';
import {
  formatAppointmentTime,
  getMinutesUntilAppointment,
  getTimeUntilAppointment,
} from './utils';

type Props = {
  onClick: (provider: Provider, time: string) => void;
  provider: Provider;
  slotPosition: 'top' | 'middle' | 'bottom';
  time: string;
};

export function ProviderAvailabilityCard({
  onClick,
  provider,
  slotPosition,
  time,
}: Props) {
  const timeBlock = useParseTimeBlockSearchParam();

  const providerName = formatProviderName(provider);
  const providerNameWithTitle = formatProviderNameWithTitle(provider);
  const formattedAppointmentTime = formatAppointmentTime(time);
  const minutesUntilAppointment = getMinutesUntilAppointment(time);
  const timeUntilAppointment = getTimeUntilAppointment(time, timeBlock);

  function handleClick() {
    tracking.trackEvent(Events.SELECT_APPOINTMENT_SLOT, {
      minutesUntilAppointment,
      slotPosition,
      timeBlock,
    });

    onClick(provider, time);
  }

  return (
    <div className="grid gap-sp-2 rounded-lg border border-border-medium bg-surface-default p-sp-2">
      <div className="flex items-center gap-sp-1.5">
        <Avatar name={providerName} src={provider.imageUrl} />

        <Paragraph className="font-semibold text-text-dark">
          {providerNameWithTitle}
        </Paragraph>
      </div>

      <Button
        priority="secondary"
        className="grid h-auto gap-0 py-sp-0.75"
        onClick={handleClick}
      >
        <Paragraph size="xs" className="text-text-highlight">
          {timeUntilAppointment}
        </Paragraph>

        {formattedAppointmentTime}
      </Button>
    </div>
  );
}
